import { render, staticRenderFns } from "./CreateItineraryItem.vue?vue&type=template&id=6591890c&scoped=true&"
import script from "./CreateItineraryItem.vue?vue&type=script&lang=js&"
export * from "./CreateItineraryItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateItineraryItem.vue?vue&type=style&index=0&id=6591890c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6591890c",
  null
  
)

export default component.exports